import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

const GlobalSettingsContext = createContext({
  settings: null,
  hereApiKey: null,
});

export function GlobalSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const ref = doc(db, "gandolapp", "publicSettings");

    return onSnapshot(
      ref,
      (snap) => {
        setSettings(snap.exists() ? snap.data() : null);
      },
      (error) => {
        console.error("Failed to load publicSettings:", error);
      },
    );
  }, []);

  const value = useMemo(() => {
    return {
      settings,
      hereApiKey:
        process.env.REACT_APP_HERE_BROWSER_API_KEY ||
        settings?.HERE_BROWSER_API_KEY ||
        null,
    };
  }, [settings]);

  return <GlobalSettingsContext.Provider value={value}>{children}</GlobalSettingsContext.Provider>;
}

export function useGlobalSettings() {
  return useContext(GlobalSettingsContext);
}
